<template>
    <div>
        <v-container>
            <v-row>
                <v-col>
                    <h2 style="padding:15px;">Reset Password</h2>
                </v-col>
            </v-row>
            <v-col v-if="spinner == false && emailSent == false">
                <v-card>
                    <v-card-title>Email for the account to reset</v-card-title>
                    <v-form ref="form" class="mx-2" lazy-validation>
                        <v-card-text>
                            <v-text-field v-model="email" v-on:keyup.enter="onSubmit"
                                :rules="emailRules"
                                label="email" required>
                            </v-text-field>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <div>
                                <v-btn
                                @click="resetPassword()" >Submit</v-btn>
                            </div>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-col>
            <v-col v-if="spinner == false && emailSent == true">
                <v-card style="padding:10px;">
                    <v-card-title style="padding-bottom:0px;">Please check your emails</v-card-title>
                    <v-card-text>
                        <p>
                            If you have entered a valid email address, Locate the email and follow the link to change your password.
                            If you cannot see the email make sure to check your spam.
                        </p>
                    </v-card-text>

                    <v-card-actions>
                        <v-col class="text-right" style="padding:0px; margin:0px;">
                            <v-btn right class="navColor" v-on:click="backToEmailEnter()">BACK</v-btn>

                        </v-col>
                    </v-card-actions>


                </v-card>
            </v-col>
        </v-container>
        <v-snackbar timeout="3000" v-model="snackbar" elevation="3">
            {{ snackbarText }}

            <template v-slot:action="{ attrs }">
                <v-btn snackbarText v-bind="attrs" @click="snackbar = false"> Close </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>
<script src="https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit" async defer></script>
<script>

</script>
<script>
import RestResource from '../RestResource.js';
import { VueReCaptcha } from "vue-recaptcha-v3";

const restResourceService = new RestResource();
export default {
    name: "ForgottenPasswordPage",
    setup() {

    },
    props: {

    },
    components: {
    },
    data: () => ({
        spinner: false,
        email: "",
        emailSent: false,
        snackbar: false,
        snackbarText: "",
        recaptchaResponse: "",
        siteKey: null,
        gotSiteKey: false,
        emailRules: [],
        token: {} 
    }),
    beforeMount : function () {
        this.getRCkey();
    },
    mounted() {
      const recaptcha = this.$recaptchaInstance
     recaptcha.showBadge()
    },
    watch:{
        email() {
            this.emailRules = [];
        }
    },
    methods: {
       
        resetPassword() {
        this.$recaptcha("login").then(token => {
          console.log("Got token !");
          this.dialog = false;
          this.token = token ;
          this.Validate();
            

        })
    },

        Validate(){
            this.emailRules = [v => !!v || 'Email is required', v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'];  
            
            let self = this;
            setTimeout(function () {
                if (self.$refs.form.validate())
                    self.SendEmailToEmail();
                else
                    return self.$emit('snack', 'Invalid email address');
            })
            
            //this.SendEmailToEmail();
        
        },
        async SendEmailToEmail() {

            //Call the backend to send an email to the user providing a link to reset the password.
            const isSent = await restResourceService.postPasswordReset(this.email, this.token);
            if (isSent)
                this.emailSent = isSent;

            
        },
        backToEmailEnter: function () {
            this.emailSent = false;
            this.getRCkey();
        },
        async getRCkey() {
            await restResourceService.getRecaptchaSiteKey().then(value => {
                this.siteKey = value;
                window.siteKey = this.siteKey;
                this.gotSiteKey = true;
                grecaptcha.render('recaptcha-main', {
                    'sitekey' : this.siteKey
                });

                grecaptcha.reset();
            }).catch(err => {
                console.log(err);
            });
        }
    },
    beforeDestroy() {
    const recaptcha = this.$recaptchaInstance
     recaptcha.hideBadge()
    },
}
</script>

<style scoped>
</style>